import React, { useEffect } from 'react';
import { FaEnvelope, FaLock, FaRegClock } from 'react-icons/fa';
import './SupportPage.css';

const faqs = [
  {
    question: 'How do I buy an item?',
    answer: 'Open an item in LadyFirst, add it to your cart, and follow the checkout steps.',
  },
  {
    question: 'How do I sell an item?',
    answer: 'Sign in, choose Upload Product, add the item details and photos, then submit your listing.',
  },
  {
    question: 'How can I check my order or delivery?',
    answer: 'Open your order history in LadyFirst and select the order to see its latest status.',
  },
  {
    question: 'I cannot sign in. What should I do?',
    answer: 'Use Forgot Password on the sign-in screen. If you still cannot access your account, email our support team.',
  },
  {
    question: 'How do I report a payment, refund, or order problem?',
    answer: 'Email us from your registered email address and include the relevant order number and a short explanation.',
  },
  {
    question: 'How can I delete my account?',
    answer: 'Use the account deletion option in the LadyFirst app. Contact support if you cannot access your account.',
  },
];

function SupportPage() {
  useEffect(() => {
    document.title = 'LadyFirst Support';
    return () => {
      document.title = 'LadyFirst';
    };
  }, []);

  return (
    <div className="support-page">
      <section className="support-hero" aria-labelledby="support-title">
        <p className="support-eyebrow">LADYFIRST HELP CENTRE</p>
        <h1 id="support-title">How can we help?</h1>
        <p>
          Get help with your LadyFirst account, buying, selling, payments,
          orders, and deliveries.
        </p>
        <a
          className="support-email-button"
          href="mailto:info.ladyfirst.me@gmail.com?subject=LadyFirst%20Support%20Request"
        >
          <FaEnvelope aria-hidden="true" />
          Email LadyFirst Support
        </a>
      </section>

      <section className="support-content" aria-label="LadyFirst support information">
        <div className="support-contact-card">
          <div className="support-card-icon" aria-hidden="true">
            <FaEnvelope />
          </div>
          <div>
            <p className="support-card-label">CONTACT US</p>
            <h2>We’re here to help</h2>
            <p>
              Send your question to our support team. Please include your
              registered email address and order or product number when relevant.
            </p>
            <a href="mailto:info.ladyfirst.me@gmail.com?subject=LadyFirst%20Support%20Request">
              info.ladyfirst.me@gmail.com
            </a>
          </div>
        </div>

        <div className="support-details">
          <div>
            <FaRegClock aria-hidden="true" />
            <span>Email support is available for all LadyFirst users.</span>
          </div>
          <div>
            <FaLock aria-hidden="true" />
            <span>Never send your password, OTP, or full payment details.</span>
          </div>
        </div>

        <section className="support-faq" aria-labelledby="faq-title">
          <div className="support-section-heading">
            <p className="support-eyebrow">QUICK ANSWERS</p>
            <h2 id="faq-title">Frequently asked questions</h2>
          </div>
          <div className="support-faq-grid">
            {faqs.map((faq) => (
              <article className="support-faq-card" key={faq.question}>
                <h3>{faq.question}</h3>
                <p>{faq.answer}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="support-bottom-card" aria-label="Contact LadyFirst support">
          <div>
            <h2>Still need help?</h2>
            <p>Tell us what happened and our support team will assist you.</p>
          </div>
          <a href="mailto:info.ladyfirst.me@gmail.com?subject=LadyFirst%20Support%20Request">
            Contact support
          </a>
        </section>
      </section>
    </div>
  );
}

export default SupportPage;
